import Header from 'component/layout/header/Header';
import ProfileTemplate from 'component/organism/profile/ProfileTemplate';
import React from 'react';

const Profile = () => {
  return (
    <>
      <Header title="Profile" />
      <ProfileTemplate />
    </>
  );
};

export default Profile;
